<template>
	<v-container grid-list-xl class="container--box white--text">
		<v-layout row wrap>
			<v-flex xs12 md12>
				<h2 class="py-5">{{ $t("title.your_membership") }}</h2>
			</v-flex>
			<v-flex xs12 md4>
				<v-container grid-list-xl>
					<v-row justify="space-around">
						<v-card>
							<v-img
								height="280px"
								:src="membership_card"
								contain
							>
								<v-app-bar flat color="rgba(0, 0, 0, 0)">
									<v-app-bar-nav-icon
										color="white"
									></v-app-bar-nav-icon>

									<v-toolbar-title
										class="text-h6 white--text pl-0"
									>
										{{ $t("label.subscriptions") }}
									</v-toolbar-title>

									<v-spacer></v-spacer>

									<v-btn
										color="white"
										icon
										:href="membership_card"
										target="_blank"
									>
										<v-icon>mdi-download</v-icon>
									</v-btn>
								</v-app-bar>
							</v-img>

							<v-card-text>
								<div class="font-weight-bold ml-8 mb-2">
									{{
										$t(
											"label.your_active_membership_subscriptions"
										)
									}}
								</div>

								<v-timeline align-top dense>
									<v-timeline-item
										v-for="subscription in subscriptions"
										:key="subscription.time"
										:color="subscription.color"
										small
									>
										<Link
											as="v-card"
											class="ma-0"
											link
											:href="
												$route(
													'membership.subscriptions.show',
													subscription.uuid
												)
											"
										>
											<v-card-title class="primary-title">
												{{
													subscription.membership_name
												}}
											</v-card-title>
											<v-card-subtitle>
												{{ subscription.code }}
											</v-card-subtitle>
											<v-card-text>
												<div>
													{{ $t("label.starts_at") }}:
													{{ subscription.starts_at }}
													<br />
													{{ $t("label.ends_at") }}:
													{{ subscription.ends_at }}
												</div>
											</v-card-text>
										</Link>
									</v-timeline-item>
								</v-timeline>
							</v-card-text>
						</v-card>
					</v-row>
				</v-container>
			</v-flex>
			<v-flex xs12 md8>
				<v-card flat color="transparent " class="ma-0 white--text">
					<v-card-title primary-title>
						{{ $t("label.memberships") }}
					</v-card-title>
					<v-card-subtitle class="white--text">
						{{ $t("label.available_memberships_to_be_subscribed") }}
					</v-card-subtitle>
					<v-card-text>
						<v-row>
							<v-col
								v-for="(membership, i) in memberships"
								:key="i"
								cols="12"
								md="6"
								class="d-flex flex-column"
							>
								<v-card
									:color="membership.color"
									class="flex d-flex flex-column"
								>
									<v-card-subtitle>
										<v-chip
											v-text="membership.price"
											color="secondary"
										></v-chip>
									</v-card-subtitle>

									<v-card-text>
										<div
											class="
												d-flex
												flex-no-wrap
												justify-space-between
											"
										>
											<div>
												<h3
													class="text-h5"
													v-text="membership.name"
												></h3>
											</div>

											<v-avatar
												class="ma-3"
												size="125"
												tile
												color="red"
											>
												<v-img
													position="top center"
													:src="membership.image_url"
												></v-img>
											</v-avatar>
										</div>
									</v-card-text>

									<v-card-actions>
										<Link
											as="v-btn"
											class="ml-2 mt-5"
											color="primary"
											:href="
												$route(
													'membership.subscriptions.create',
													{
														membership:
															membership.uuid,
													}
												)
											"
										>
											<v-icon left
												>mdi-satellite-uplink</v-icon
											>
											{{ $t("label.subscribe") }}
										</Link>
										<v-spacer></v-spacer>

										<v-btn icon @click="show = !show">
											<v-icon>{{
												show
													? "mdi-chevron-up"
													: "mdi-chevron-down"
											}}</v-icon>
										</v-btn>
									</v-card-actions>
									<v-expand-transition>
										<div v-show="show">
											<v-divider></v-divider>
											<v-card-text
												v-html="membership.description"
											>
											</v-card-text>
										</div>
									</v-expand-transition>
								</v-card>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
	import { Link } from "@inertiajs/inertia-vue";
	export default {
		components: {
			Link,
		},

		props: ["memberships", "subscriptions", "membership_card"],

		data() {
			return {
				show: false,
			};
		},
	};
</script>